import { motion } from "framer-motion";
interface ReferallQuestionProps {
  label: string;
  onClick?: () => void;
}

const ReferralQuestion = ({
  label,
  onClick = () => {},
}: ReferallQuestionProps) => (
  <div
    className={`rounded-md p-[2px] bg-gradient-to-b from-[#1b466e] to-[#196ebe]`}
  >
    <motion.button
      onClick={onClick}
      whileTap={{ scale: 0.98 }}
      className="w-full text-center p-4 rounded-md text-white text-[1rem] bg-gradient-to-b from-[#123555] to-[#1c4f7f]/70"
      aria-label={label}
    >
      {label}
    </motion.button>
  </div>
);

export default ReferralQuestion;
